import React from 'react';
import { copyFor, routes } from 'config';
import { StandardRow, StandardRowLoading } from 'components/standard-row';
import { useReferralData } from 'hooks/use-referral-data.hook';
import { UserSettingsBase } from './user-settings.base';

const { referrals } = routes();
const getCopy = copyFor('settings.userSettings');

interface Props {
  isWhale: boolean;
}

export const UserSettingsActive = ({ isWhale }: Props) => {
  const { data, loading } = useReferralData({ skip: isWhale });
  const { excludeSavingsLanguage = true } = data || {};

  return (
    <UserSettingsBase>
      {loading ? (
        <StandardRowLoading
          hasBottomBorder
          includesBuffer={true}
          bufferWidth="32px"
          mobileBufferWidth="32px"
        />
      ) : (
        <StandardRow
          iconLinkProps={{ to: referrals }}
          includesBuffer={true}
          heading={getCopy('referrals.heading')}
          headingTag="h3"
          text={
            excludeSavingsLanguage
              ? getCopy('referrals.impactCopy')
              : getCopy('referrals.savingsCopy')
          }
          hasBottomBorder
          bufferWidth="32px"
          mobileBufferWidth="32px"
        />
      )}
    </UserSettingsBase>
  );
};
